import React from 'react';
import { Button, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as pages from '../../constants/journal';
import { faFile } from '@whitebox-learning/fontawesome-pro-light-svg-icons';

const Tree = ({ title, selected, selectPage }) => {
  const links = [
    { title: 'Introduction', code: pages.JOURNAL_INTRO },
    { title: 'Design Challenge', code: pages.JOURNAL_DESIGN_CHALLENGE },
    { title: 'Gradebook', code: pages.JOURNAL_GRADEBOOK },
    { title: 'Engineering Logs', code: pages.JOURNAL_LOGS },
    { title: 'Final Reflection', code: pages.JOURNAL_REFLECTION },
  ];
  return (
    <div className="sidebar-nav box box-col" role="complementary" aria-label={`${title} navigation`}>
      <div className="box box-min">
        <h1 className="title">{title}</h1>
      </div>
      <div className="box scroll">
        <Nav className="flex-column">
          {links.map((link) => (
            <Nav.Item
              key={link.code}
              className="d-flex justify-content-between align-items-center"
            >
              <span>{link.title}</span>
              <Button
                size="sm"
                variant={selected === link.code ? 'wb' : 'light'}
                onClick={() => selectPage(link.code)}
              >
                <FontAwesomeIcon icon={faFile} />
              </Button>
            </Nav.Item>
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default Tree;
